export default "__VITE_ASSET__829825ff__"